export default __webpack_public_path__ + "static/media/Jyotirmaya Choudhury, Member, NIBA Alumni Association.ff4ae9cb.jpg";